import React, { useMemo } from 'react';

import styled from 'styled-components';
import { Empty } from 'antd';

import { ContentWrapper, LeftWrapper, RightWrapper } from '../../../Components/fullCard';

import DoughnutChart from '../../../Components/doughnutChart';
import InfoContainer from '../../../Components/InfoContainer';
import { useTranslation } from 'react-i18next';

const SingleViewPieWithDescription = ({ data, noDataMessage, loader }) => {
  const { t } = useTranslation();

  const doughnutParsedData = useMemo(() => {
    return data ? data.map((item) => ({ title: item.title, percentage: item.percentage })) : [];
  }, [data]);
  if(!(!!loader)){
    if (doughnutParsedData.length === 0) return <Empty description={noDataMessage || t('noData')} />;
  }
  return (
    <ContentWrapper>
      <LeftWrapper>
        <DoughnutChart style={{ justifyContent: 'center' }} data={doughnutParsedData} width={300} height={300} />
      </LeftWrapper>
      <RightWrapper>
        {data?.map((item, index) =>
          data.length > 1 ? (
            <InfoContainer item={item} id={index} index={index} />
          ) : (
            <InfoWrapper>
              <InfoContainer item={item} id={index} index={index} />
            </InfoWrapper>
          ),
        )}
      </RightWrapper>
    </ContentWrapper>
  );
};

const InfoWrapper = styled.div`
  // margin-top: 100px;
  @media screen and (max-width: 820px) {
    margin-top: 0px;
  }
`;

export default SingleViewPieWithDescription;
